import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { MultiSelect } from '../ui/MultiSelect';
import { DatePicker } from '../ui/DatePicker';
import { FileUpload } from '../ui/FileUpload';
import { RadioGroup } from '../ui/RadioGroup';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import { calculateDuration } from '../../utils/dateUtils';
interface Step2Props {
  data: {
    nameBangla: string;
    nameEnglish: string;
    trainingId: string;
    trainers: string[];
    officeOrder?: File;
    participantList?: File;
    startDate: string;
    endDate: string;
    venueType: string;
    onlineLink: string;
    venueId: string;
  };
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  trainers: Array<{
    value: string;
    label: string;
  }>;
  venues: Array<{
    value: string;
    label: string;
  }>;
  trainings: Array<{
    value: string;
    label: string;
  }>;
  onAddTrainer: (trainer: any) => void;
  onAddVenue: (venue: any) => void;
}
export function Step2BatchInfo({
  data,
  onChange,
  errors,
  trainers,
  venues,
  trainings,
  onAddTrainer,
  onAddVenue
}: Step2Props) {
  const [showTrainerModal, setShowTrainerModal] = useState(false);
  const [showVenueModal, setShowVenueModal] = useState(false);
  const [trainerForm, setTrainerForm] = useState({
    name: '',
    phone: '',
    email: ''
  });
  const [venueForm, setVenueForm] = useState({
    name: '',
    address: '',
    capacity: 0
  });
  const duration = calculateDuration(data.startDate, data.endDate);
  const handleSaveTrainer = () => {
    onAddTrainer(trainerForm);
    setShowTrainerModal(false);
    setTrainerForm({
      name: '',
      phone: '',
      email: ''
    });
  };
  const handleSaveVenue = () => {
    onAddVenue(venueForm);
    setShowVenueModal(false);
    setVenueForm({
      name: '',
      address: '',
      capacity: 0
    });
  };
  return <>
      <Card title="Batch Information" data-id="element-36">
        <div className="space-y-6" data-id="element-37">
          <Input label="Batch Name (Bangla)" value={data.nameBangla} onChange={e => onChange('nameBangla', e.target.value)} error={errors.nameBangla} placeholder="ব্যাচের নাম লিখুন" required data-id="element-38" />

          <Input label="Batch Name (English)" value={data.nameEnglish} onChange={e => onChange('nameEnglish', e.target.value)} error={errors.nameEnglish} placeholder="Enter batch name" required data-id="element-39" />

          <Select label="Training" value={data.trainingId} onChange={e => onChange('trainingId', e.target.value)} options={trainings} error={errors.trainingId} required data-id="element-40" />

          <div data-id="element-41">
            <div className="flex items-end gap-2" data-id="element-42">
              <div className="flex-1" data-id="element-43">
                <MultiSelect label="Trainers Assigned" options={trainers} value={data.trainers} onChange={value => onChange('trainers', value)} error={errors.trainers} placeholder="Select trainers" data-id="element-44" />
              </div>
              <Button variant="secondary" size="md" onClick={() => setShowTrainerModal(true)} className="mb-0" title="Add New Trainer" data-id="element-45">
                <Plus className="w-4 h-4" data-id="element-46" />
              </Button>
            </div>
          </div>

          <FileUpload label="Office Order" value={data.officeOrder} onChange={file => onChange('officeOrder', file)} accept=".pdf,.doc,.docx" data-id="element-47" />

          <FileUpload label="Participant List" value={data.participantList} onChange={file => onChange('participantList', file)} accept=".pdf,.xlsx,.csv" data-id="element-48" />

          <div className="grid grid-cols-3 gap-4" data-id="element-49">
            <DatePicker label="Training Start Date" value={data.startDate} onChange={value => onChange('startDate', value)} error={errors.startDate} required data-id="element-50" />

            <DatePicker label="Training End Date" value={data.endDate} onChange={value => onChange('endDate', value)} error={errors.endDate} min={data.startDate} required data-id="element-51" />

            <Input label="Duration" value={duration > 0 ? `${duration} Days` : ''} readOnly disabled data-id="element-52" />
          </div>

          <RadioGroup label="Venue Type" name="venueType" value={data.venueType} onChange={value => onChange('venueType', value)} options={[{
          value: 'online',
          label: 'Online'
        }, {
          value: 'offline',
          label: 'Offline'
        }]} data-id="element-53" />

          {data.venueType === 'online' && <Input label="Online Link / Meeting URL" value={data.onlineLink} onChange={e => onChange('onlineLink', e.target.value)} error={errors.onlineLink} placeholder="https://meet.google.com/..." required data-id="element-54" />}

          {data.venueType === 'offline' && <div className="flex items-end gap-2" data-id="element-55">
              <div className="flex-1" data-id="element-56">
                <Select label="Venue Location" value={data.venueId} onChange={e => onChange('venueId', e.target.value)} options={venues} error={errors.venueId} required data-id="element-57" />
              </div>
              <Button variant="secondary" size="md" onClick={() => setShowVenueModal(true)} className="mb-0" title="Add New Venue" data-id="element-58">
                <Plus className="w-4 h-4" data-id="element-59" />
              </Button>
            </div>}
        </div>
      </Card>

      <Modal isOpen={showTrainerModal} onClose={() => setShowTrainerModal(false)} title="Add New Trainer" size="sm" footer={<>
            <Button variant="secondary" onClick={() => setShowTrainerModal(false)} data-id="element-61">
              Cancel
            </Button>
            <Button onClick={handleSaveTrainer} data-id="element-62">Add Trainer</Button>
          </>} data-id="element-60">
        <div className="space-y-4" data-id="element-63">
          <Input label="Name" value={trainerForm.name} onChange={e => setTrainerForm({
          ...trainerForm,
          name: e.target.value
        })} required data-id="element-64" />
          <Input label="Phone" value={trainerForm.phone} onChange={e => setTrainerForm({
          ...trainerForm,
          phone: e.target.value
        })} required data-id="element-65" />
          <Input label="Email" type="email" value={trainerForm.email} onChange={e => setTrainerForm({
          ...trainerForm,
          email: e.target.value
        })} required data-id="element-66" />
        </div>
      </Modal>

      <Modal isOpen={showVenueModal} onClose={() => setShowVenueModal(false)} title="Add New Venue" size="sm" footer={<>
            <Button variant="secondary" onClick={() => setShowVenueModal(false)} data-id="element-68">
              Cancel
            </Button>
            <Button onClick={handleSaveVenue} data-id="element-69">Add Venue</Button>
          </>} data-id="element-67">
        <div className="space-y-4" data-id="element-70">
          <Input label="Venue Name" value={venueForm.name} onChange={e => setVenueForm({
          ...venueForm,
          name: e.target.value
        })} required data-id="element-71" />
          <Input label="Address" value={venueForm.address} onChange={e => setVenueForm({
          ...venueForm,
          address: e.target.value
        })} required data-id="element-72" />
          <Input label="Capacity" type="number" value={venueForm.capacity.toString()} onChange={e => setVenueForm({
          ...venueForm,
          capacity: parseInt(e.target.value) || 0
        })} required data-id="element-73" />
        </div>
      </Modal>
    </>;
}